/**
 * Common base class for TabGroupManager, QuickAccessActionManager and PanelManager.
 *
 * Copyright 2014-2018 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dijit/registry",
    "MW/uiframework/UIBuilderFactory"
], function (declare, lang, registry, UIBuilderFactory) {
    return declare(null, {

        constructor: function (args) {
            this._contextManagerImpl = args.contextManagerImpl;
            this._uiBuilder = args.uiBuilder || UIBuilderFactory.getInstance();

            this._handles = [];
            this._handles.push(this._contextManagerImpl.watch("currentContext", lang.hitch(this, this._currentContextChangedCallback)));
            this._handles.push(this._contextManagerImpl.watch("secondaryContext", lang.hitch(this, this._secondaryContextChangedCallback)));
        },

        _currentContextChangedCallback: function (name, oldValue, newValue) {
            // Only proceed if the context has changed
            if (newValue !== oldValue && (!newValue || JSON.stringify(oldValue) !== JSON.stringify(newValue))) {
                this._update(newValue, this._contextManagerImpl.secondaryContext);
            }
        },

        _secondaryContextChangedCallback: function (name, oldValue, newValue) {
            // Only proceed if the secondary context has changed
            if (newValue !== oldValue && (!newValue || JSON.stringify(oldValue) !== JSON.stringify(newValue))) {
                this._update(this._contextManagerImpl.currentContext, newValue);
            }
        },

        _update: function (context, secondaryContext) {},

        cleanup: function () {
            this._handles.forEach(function (handle) {
                handle.remove();
            });
        }
    });
});
